<template>
    <div class="g g_b2bHygiene" v-if="displayContent">
        <section-hero />
        <section-banner dico-key="safety" />
        <section-dispenser />
        <section-app />
        <section-banner dico-key="environment" />
        <section-faq />
    </div>
</template>

<script>
import SectionHero from '@/components/section/SectionHero'
import SectionBanner from '@/components/section/SectionBanner'
import SectionDispenser from '@/components/section/SectionDispenser'
import SectionApp from '@/components/section/SectionApp'
import SectionFaq from '@/components/section/SectionFaq'

export default {
    name: 'App',
    components: {
        SectionHero,
        SectionBanner,
        SectionDispenser,
        SectionApp,
        SectionFaq
    },
    computed: {
        displayContent () {
            return this.$json !== null
        }
    }
}
</script>

<style lang="sass">
@import ~assets/sass/common
@import ~assets/sass/b2bHygiene
</style>
